export default __webpack_public_path__ + "static/media/QK_9776.d7c75e44.jpg";